import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "id", "value", "disabled"];
import React from "react";
import { BaseRadioButton, BaseRadioButtonContainer, BaseRadioIndicator, BaseRadioLabel } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RadioButton = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
    id = _ref.id,
    value = _ref.value,
    disabled = _ref.disabled,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(BaseRadioButtonContainer, {
    ref: forwardedRef,
    children: [/*#__PURE__*/_jsx(BaseRadioButton, _extends({
      disabled: disabled,
      value: value,
      id: id
    }, restProps, {
      children: /*#__PURE__*/_jsx(BaseRadioIndicator, {
        disabled: disabled
      })
    })), /*#__PURE__*/_jsx(BaseRadioLabel, {
      disabled: disabled,
      htmlFor: id,
      children: label
    })]
  });
});
RadioButton.displayName = "RadioButton";
export default RadioButton;